export default {
  fill: 'SHOPPINGCARTITEMS_ACTIONS_FILL',
  addItemToCart: 'SHOPPINGCARTITEMS_ACTIONS_ADD_TO_CART',
  updateLine: 'SHOPPINGCARTITEMS_ACTIONS_UPDATE_LINE',
  deleteProduct: 'SHOPPINGCARTITEMS_ACTIONS_DELETE_PRODUCT_FROM_CART',
  placeOrder: 'SHOPPINGCARTITEMS_ACTIONS_PLACE_ORDER',
  openCart: 'SHOPPINGCARTITEMS_ACTIONS_OPEN_CART',
  clearWishlist: 'SHOPPINGCARTITEMS_ACTIONS_CLEAR_WISHLIST'
}
